import React from 'react';
import { Spin, SpinProps } from '../Spin';
import Styles from './Loading.module.less';
import { classes } from '../../lib';

type LoadingProps = SpinProps & {
    containerStyle?: React.CSSProperties;
    containerClassName?: string;
    innerContainerClassName?: string;
};

const Loading = ({
    containerClassName,
    containerStyle,
    innerContainerClassName,
    ...props
}: LoadingProps): JSX.Element => (
    <div
        className={classes(
            'horizontal stretch-stretch',
            Styles.loading,
            containerClassName
        )}
        style={containerStyle}>
        <div
            className={classes(
                'horizontal center-middle',
                innerContainerClassName
            )}>
            <Spin {...props} />
        </div>
    </div>
);

export { Loading };
export type { LoadingProps };
